import cn from "classnames";
import React, { useState } from "react";
import { Scrollbars } from "react-custom-scrollbars-2";
import BgTask from "./item";

const BgTasks = (props) => {
    const [show, setShow] = useState(false); // wait more background tasks
    const [opened, setOpened] = useState(true);
    return (
        <div className={cn("bg-tasks", { "d-none": !show })}>
            <div className="bg-tasks__header">
                <div className="d-flex">
                    <div
                        className={cn("bg-tasks__collapse-btn", {
                            "bg-tasks__collapse-btn--down": !opened,
                            "bg-tasks__collapse-btn--up": opened,
                        })}
                        onClick={() => setOpened(!opened)}
                    />
                    Фоновые задачи
                    <div className="bg-tasks__loader">
                        <i className="loading loading--small" />
                    </div>
                    <i className="icon-uEA85-check-circle text-success ml-2" />
                </div>
                <div className="bg-tasks__close-btn" onClick={() => setShow(false)}>
                    &times;
                </div>
            </div>
            <div className={cn("bg-tasks__body-wrap", { "bg-tasks__body-wrap--opened": opened })}>
                <Scrollbars autoHeight>
                    <div className="bg-tasks__scroll">
                        <div className="bg-tasks__body">
                            {Object.values(props.items).map((item, i) => (
                                <BgTask
                                    key={item.key || i}
                                    item={item}
                                    updateItem={props.update}
                                    removeItem={props.remove}
                                    history={props.history}
                                    location={props.location}
                                />
                            ))}
                        </div>
                    </div>
                </Scrollbars>
            </div>
        </div>
    );
};

export default BgTasks;
